module.exports = __webpack_public_path__ + "img/send-icon1.2efea55b.svg";